export const DayOfTheWeekCheckboxSet = ({setWeeklyAvailability, day, weeklyAvailability}) => {

    return (
      <fieldset className="border-0">
        <legend className="sr-only">Notifications</legend>
        <div className="space-y-5">
          <div className="relative flex items-start">
            <div className="flex h-6 items-center">
              <input
                id="comments"
                aria-describedby="comments-description"
                name="comments"
                type="checkbox"
                checked={weeklyAvailability[day].Morning}
                onChange={(e) => setWeeklyAvailability((prev) => ({...prev, [day]: {...prev[day], Morning: e.target.checked}}))}
                className="h-4 w-4 rounded border-solid border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
            </div>
            <div className="ml-3 text-sm leading-6">
              <label htmlFor="comments" className="font-medium text-gray-900">
                Morning
              </label>
            </div>
          </div>
          <div className="relative flex items-start">
            <div className="flex h-6 items-center">
              <input
                id="candidates"
                aria-describedby="candidates-description"
                name="candidates"
                type="checkbox"
                checked={weeklyAvailability[day].Afternoon}
                onChange={(e) => setWeeklyAvailability((prev) => ({...prev, [day]: {...prev[day], Afternoon: e.target.checked}}))}
                className="h-4 w-4 rounded border-solid border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
            </div>
            <div className="ml-3 text-sm leading-6">
              <label htmlFor="candidates" className="font-medium text-gray-900">
                Afternoon
              </label>
            </div>
          </div>
          <div className="relative flex items-start">
            <div className="flex h-6 items-center">
              <input
                id="offers"
                aria-describedby="offers-description"
                name="offers"
                type="checkbox"
                checked={weeklyAvailability[day].Evening}
                onChange={(e) => setWeeklyAvailability((prev) => ({...prev, [day]: {...prev[day], Evening: e.target.checked}}))}
                className="h-4 w-4 rounded border-solid border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
            </div>
            <div className="ml-3 text-sm leading-6">
              <label htmlFor="offers" className="font-medium text-gray-900">
                Evening
              </label>
            </div>
          </div>
        </div>
      </fieldset>
    )
  }